export function isBookingUrl(url: any) {
  const pattern =
    /^(https?:\/\/)?((((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,})|((\d{1,3}\.){3}\d{1,3})))(:\d+)?(\/[-a-z\d%_.~+]*)*\.en-gb\.html(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
  return pattern.test(url);
}
